import { render } from "./SidebarMenuItem.vue?vue&type=template&id=e2d3ab48&scoped=true"
import script from "./SidebarMenuItem.vue?vue&type=script&lang=js"
export * from "./SidebarMenuItem.vue?vue&type=script&lang=js"

import "./SidebarMenuItem.vue?vue&type=style&index=0&id=e2d3ab48&scoped=true&lang=scss"

import exportComponent from "/home/tachyon/wardrobe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2d3ab48"]])

export default __exports__